/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SnapshotPartialUpdate
 */
export interface SnapshotPartialUpdate {
    /**
     * 
     * @type {number}
     * @memberof SnapshotPartialUpdate
     */
    workspace?: number;
    /**
     * 
     * @type {string}
     * @memberof SnapshotPartialUpdate
     */
    name?: string;
}

export function SnapshotPartialUpdateFromJSON(json: any): SnapshotPartialUpdate {
    return SnapshotPartialUpdateFromJSONTyped(json, false);
}

export function SnapshotPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SnapshotPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'workspace': !exists(json, 'workspace') ? undefined : json['workspace'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function SnapshotPartialUpdateToJSON(value?: SnapshotPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'workspace': value.workspace,
        'name': value.name,
    };
}


